import _color from '@/assets/utils/color.js';
<template>
  <div class="mx-auto w-full">
    <vx-card>
      <div class="vx-row">
        <div class="vx-col" style="width: 230px; text-align: right">
          <span>CMAN Details</span>
        </div>
        <div class="vx-col">
          <vs-input
            class="w-full"
            icon-pack="feather"
            icon="icon-code"
            icon-no-border
            v-model="cmansDetailsNumber"
            :readonly="true"
          />
        </div>
      </div>

      <div class="vx-row mt-4">
        <div class="vx-col" style="width: 230px; text-align: right">
          <span>Dangerous Goods Code</span>
        </div>
        <div class="vx-col">
          <vs-input
            class="w-full"
            icon-pack="feather"
            icon="icon-code"
            icon-no-border
            @blur="$v.dgcode.$touch()"
            v-model="dgcode"
          />
          <p v-if="$v.dgcode.$error & $v.dgcode.$dirty">{{ lang_formvalid }}</p>
        </div>
      </div>

      <div class="vx-row mt-4">
        <div class="vx-col mt-2" style="width: 230px; text-align: right">
          <span>IMO Class</span>
        </div>
        <div class="vx-col sm:w-2/4 w-1/2">
          <vs-input
            class="w-full"
            icon-pack="feather"
            icon="icon-user"
            icon-no-border
            @blur="$v.imoclass.$touch()"
            v-model="imoclass"
          />
          <p v-if="$v.imoclass.$error & $v.imoclass.$dirty">
            {{ lang_formvalid }}
          </p>
        </div>
      </div>

      <div class="vx-row mt-4">
        <div class="vx-col mt-2" style="width: 230px; text-align: right">
          <span>UNDG Number</span>
        </div>
        <div class="vx-col sm:w-2/4 w-1/2">
          <vs-input
            class="w-full"
            icon-pack="feather"
            icon="icon-user"
            icon-no-border
            @blur="$v.undgnumber.$touch()"
            v-model="undgnumber"
          />
          <p v-if="$v.undgnumber.$error & $v.undgnumber.$dirty">
            {{ lang_formvalid }}
          </p>
        </div>
      </div>

      <div class="vx-row mt-6">
        <div class="vx-col w-full">
          <vs-button
            class="mr-3 mb-2"
            @click="onSubmit"
            :disabled="$v.$anyError"
            >Submit</vs-button
          >
          <vs-button color="warning" type="border" class="mb-2" @click="clsd"
            >Back</vs-button
          >
        </div>
      </div>
    </vx-card>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import Datepicker from "vuejs-datepicker";
import moment from "moment";

import axios from "axios";
import { BASE_API_URL } from "@/constants/index.ts";

export default {
  data() {
    return {
      businessPartnersCode: "",
      companyGroupsCode: "",
      userid: "",
      resback: "",
      btn_submit: "",
      btn_reset: "",
      lang_formvalid: "Please Enter Correct Information",
      add_complete: "Update Complete",
      dgcode: "",
      imoclass: "",
      undgnumber: "",
      editor: "",
      readonly: true,
    };
  },
  validations: {
    dgcode: {
      required,
    },
    imoclass: {
      required,
    },
    undgnumber: {
      required,
    },
  },
  components: {
    Datepicker,
  },
  props: ["acstate", "recid", "cmansDetailsNumber"],
  methods: {
    clsd: function () {
      // this.dgcode = this.imoclass = this.undgnumber = "";
      let vm = this;
      vm.$emit("grid");
    },
    format_date(value) {
      if (value) {
        return moment(String(value)).format("YYYY-MM-DD");
      }
    },
    async onSubmit() {
      // alert("Hi");
      this.$v.$touch();

      let vm = this;

      if (this.dgcode == "") {
        // alert("Please Enter The Informaiton");
        this.$vs.notify({
          position: "top-right",
          color: "danger",
          title: "Data Not Complete",
          text: this.lang_formvalid,
        });
        return;
      }

      const formData = {
        dgcode: this.dgcode,
        cmansDetailsNumber: this.cmansDetailsNumber,
        imoclass: this.imoclass,
        undgnumber: this.undgnumber,
        acstate: this.acstate,
        number: this.recid,
        companyGroupsCode: this.companyGroupsCode,
        editor: String(this.userid),
      };

      const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));

      if (token) {
        try {
          const response = await axios.post(
            `${BASE_API_URL}/inbound-svc/dangerousgoods/create`,
            formData,
            {
              headers: { Authorization: "Bearer " + token.accessToken },
            }
          );

          if (response.data.status != "success") {
            this.$vs.notify({
              position: "top-right",
              color: "danger",
              title: "Error",
              text: response.data.message,
            });
          } else {
            this.$vs.notify({
              position: "top-right",
              color: "success",
              title: "Success",
              text: response.data.message,
            });
            vm.$emit("grid");
          }
        } catch (error) {
          // return error;
          alert("กรุณาเข้าระบบอีกครั้ง");
          // await this.$router.replace("/pages/login/");
        }
      }
    },
    async checkProfiles() {
      const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));

      if (token) {
        const decoded = JSON.parse(
          Buffer.from(token.accessToken.split(".")[1], "base64").toString()
        );

        try {
          // const response = await axios.get(`${BASE_API_URL}/auth/profile`, {
          //   headers: { Authorization: "Bearer " + token.accessToken }
          // });

          // console.log(response.data);
          this.userid = decoded.userId;
          this.userRole = decoded.userRole;

          this.businessPartnersCode = decoded.businessPartnersCode;
          this.companyGroupsCode = decoded.companyGroupsCode;
          // console.log(decoded);
        } catch (error) {
          alert("กรุณาเข้าระบบอีกครั้ง");
          await this.$router.replace("/pages/login/");
        }
      }
    },
  },
  async created() {
    this.checkProfiles();

    // console.log(this.lang_number);
    // console.log(this.recid);
    if (this.recid != "0") {
      // alert("Edit");
      try {
        this.readonly = true;
        const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));

        const response = await axios.get(
          `${BASE_API_URL}/inbound-svc/dangerousgoods/${this.recid}`,
          {
            headers: { Authorization: "Bearer " + token.accessToken },
          }
        );

        if (!response.data) {
          this.loading = false;
          this.$vs.notify({
            position: "top-right",
            color: "danger",
            title: "Error from Backend",
            text: response.data.message,
          });
        } else {
          setTimeout(() => {
            this.dgcode = response.data.dgcode;
            this.imoclass = response.data.imoclass;
            this.undgnumber = response.data.undgnumber;
          }, 500);
        }
      } catch (error) {
        this.data = [];
        this.total = 0;
        this.loading = false;
        // throw error;
        alert("กรุณาเข้าระบบอีกครั้ง");
        this.$router.replace("/pages/login/");
      }
    } else {
      let vm = this;
      vm.readonly = false;
      // vm.clsd();
    }
  },
};
</script>

<style scoped>
p {
  color: red;
}
</style>
